export default __webpack_public_path__ + "static/media/meat.6cf0dd4d.svg";